import { createGetTextResources } from "../../../shared/utils/text-resources-algemeen";

export const getOnderpandTextResources = createGetTextResources({
  constructieOmschrijving: `Geef de juiste erfpachtsconstructie of koperssteun in wanneer deze niet voorkomt in de keuzelijst, maar wel goedgekeurd is door NHG. Kijk op https://www.nhg.nl/professional/geaccepteerde-erfpachtconstructies-en-koperssteun voor de beschikbare constructies.`
});
